var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "#8CA6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5068 6.44714C14.8121 6.72703 14.8328 7.20146 14.5529 7.5068L9.05287 13.5068C8.91464 13.6576 8.72081 13.7454 8.51629 13.7498C8.31178 13.7543 8.11432 13.675 7.96967 13.5303L5.46967 11.0303C5.17678 10.7374 5.17678 10.2626 5.46967 9.96967C5.76256 9.67678 6.23744 9.67678 6.53033 9.96967L8.47644 11.9158L13.4471 6.49321C13.727 6.18787 14.2015 6.16724 14.5068 6.44714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneNotify);
export default __webpack_public_path__ + "static/media/done-notify.e4fb3039bac1beae66eaca1e1307f059.svg";
export { ForwardRef as ReactComponent };